import { useCallback } from 'react';
import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
// @ts-expect-error Untyped import
import getReportingPropertyGroups from 'reporting-data/properties/groups';
export const useFetchPropertyGroupsWithFormatter = (dataType, customResultFormatter, isUnifiedEvent = false) => {
  const resultFormatter = useCallback(response => {
    const properties = response.filter(group => {
      var _group$get2;
      if (isUnifiedEvent) {
        var _group$get;
        return !!((_group$get = group.get('properties')) !== null && _group$get !== void 0 && _group$get.size);
      }
      return !!group.get('displayName') && !!((_group$get2 = group.get('properties')) !== null && _group$get2 !== void 0 && _group$get2.size);
    });
    if (customResultFormatter) {
      return customResultFormatter(properties);
    }
    return properties;
  }, [customResultFormatter, isUnifiedEvent]);
  const fetcher = useCallback(() => {
    return getReportingPropertyGroups(dataType);
  }, [dataType]);
  return useAsyncFetcher({
    fetcher,
    resultFormatter
  });
};